export enum GuidedChangeEventStep {
  SelectConfiguration = "select-configuration",
  SelectOption = "select-option",
  SelectProductToReplace = "select-product-to-replace",
  ReviewConfiguration = "review-configuration",
  ReviewImpact = "review-impact",
  Review = "review",
}

export enum GuidedChangeEventConfigType {
  CheckoutConfig = "checkoutConfig",
  ProductOfferingConfig = "productOfferingConfig",
}
